import * as types from './types'
import * as actions from './actions'
import * as getters from './getters'

const state = {
  selectedDay: '',
  allPrograms: [
    {
      dayName: 'lunes',
      programs: [
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuedo, Ranchera, Latinoamericana',
          announcers: '',
          startTime: '00:00',
          endTime: '04:00',
          id: 1
        },
        {
          title: 'DEL CAMPO A LA CIUDAD',
          description: 'Programa musical: Música Latinoamericana y Cumbias del Recuerdo.',
          announcers: 'Periodista Socrates Machaca',
          startTime: '04:00',
          endTime: '06:00',
          id: 2
        },
        {
          title: 'RCC INFORMANDO - PRIMERA EDICION',
          description: '',
          announcers: 'Abog. Carlos Ticona Oviedo y Lic. Rodolfo Pastor',
          startTime: '06:00',
          endTime: '09:00',
          id: 3
        },
        {
          title: 'RCC INFORMANDO - SEGUNDA EDICION',
          description: '',
          announcers: 'Periodista Pocho Meza y Lic. Rodolfo Pastor Caceres',
          startTime: '09:00',
          endTime: '12:00',
          id: 4
        },
        {
          title: 'JARANA CRIOLLA',
          description: '',
          announcers: 'Lic. Mario Levano',
          startTime: '12:00',
          endTime: '13:00',
          id: 5
        },
        {
          title: 'ENLACE REGIONAL SUR',
          description: '',
          announcers: 'Periodistas de la Red de Comunicación Regional',
          startTime: '13:00',
          endTime: '14:00',
          id: 6
        },
        {
          title: 'RCC INFORMANDO - TERCERA EDICION',
          description: '',
          announcers: 'Periodistas Javier Rugos y Rouse Choque.',
          startTime: '14:00',
          endTime: '16:00',
          id: 7
        },
        {
          title: 'CONCERTANDO',
          description: '',
          announcers: 'Lic. Elmer Malaga',
          startTime: '16:00',
          endTime: '17:00',
          id: 8
        },
        {
          title: 'TARDES MUSICALES EN RCC',
          description: 'Programa musical',
          announcers: ' DJ Walter Junior',
          startTime: '17:00',
          endTime: '18:00',
          id: 9
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '18:00',
          endTime: '20:00',
          id: 10
        },
        {
          title: 'LOS CLASICOS DE LA SALSA',
          description: 'Programa musical con la mejor Salsa Clasica con sus mejores exponentes y sus exitos en Estudio y en Concierto',
          announcers: '',
          startTime: '20:00',
          endTime: '22:00',
          id: 11
        },
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras, Latinoamericana.',
          announcers: '',
          startTime: '22:00',
          endTime: '24:00',
          id: 12
        }
      ]
    },
    {
      dayName: 'martes',
      programs: [
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuedo, Ranchera, Latinoamericana',
          announcers: '',
          startTime: '00:00',
          endTime: '04:00',
          id: 13
        },
        {
          title: 'DEL CAMPO A LA CIUDAD',
          description: 'Programa musical: Música Latinoamericana y Cumbias del Recuerdo.',
          announcers: 'Periodista Socrates Machaca',
          startTime: '04:00',
          endTime: '06:00',
          id: 14
        },
        {
          title: 'RCC INFORMANDO - PRIMERA EDICION',
          description: '',
          announcers: 'Abog. Carlos Ticona Oviedo y Lic. Rodolfo Pastor',
          startTime: '06:00',
          endTime: '09:00',
          id: 15
        },
        {
          title: 'RCC INFORMANDO - SEGUNDA EDICION',
          description: '',
          announcers: 'Periodista Pocho Meza y Lic. Rodolfo Pastor Caceres',
          startTime: '09:00',
          endTime: '12:00',
          id: 16
        },
        {
          title: 'JARANA CRIOLLA',
          description: '',
          announcers: 'Lic. Mario Levano',
          startTime: '12:00',
          endTime: '13:00',
          id: 17
        },
        {
          title: 'ENLACE REGIONAL SUR',
          description: '',
          announcers: 'Periodistas de la Red de Comunicación Regional',
          startTime: '13:00',
          endTime: '14:00',
          id: 18
        },
        {
          title: 'RCC INFORMANDO - TERCERA EDICION',
          description: '',
          announcers: 'Periodistas Javier Rugos y Rouse Choque.',
          startTime: '14:00',
          endTime: '16:00',
          id: 19
        },
        {
          title: 'CONCERTANDO',
          description: 'Lic. Elmer Malaga.',
          announcers: '',
          startTime: '16:00',
          endTime: '17:00',
          id: 20
        },
        {
          title: 'TARDES MUSICALES EN RCC',
          description: 'Programa musical',
          announcers: 'DJ Walter Junior.',
          startTime: '17:00',
          endTime: '18:00',
          id: 21
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '18:00',
          endTime: '20:00',
          id: 22
        },
        {
          title: 'LOS CLASICOS DE LA SALSA',
          description: 'Programa musical con la mejor Salsa Clasica con sus mejores exponentes y sus exitos en Estudio y en Concierto.',
          announcers: '',
          startTime: '20:00',
          endTime: '22:00',
          id: 23
        },
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras, Latinoamericana.',
          announcers: '',
          startTime: '22:00',
          endTime: '24:00',
          id: 24
        }
      ]
    },
    {
      dayName: 'miércoles',
      programs: [
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuedo, Ranchera, Latinoamericana',
          announcers: '',
          startTime: '00:00',
          endTime: '04:00',
          id: 25
        },
        {
          title: 'DEL CAMPO A LA CIUDAD',
          description: 'Programa musical: Música Latinoamericana y Cumbias del Recuerdo.',
          announcers: 'Periodista Socrates Machaca',
          startTime: '04:00',
          endTime: '06:00',
          id: 26
        },
        {
          title: 'RCC INFORMANDO - PRIMERA EDICION',
          description: '',
          announcers: 'Abog. Carlos Ticona Oviedo y Lic. Rodolfo Pastor',
          startTime: '06:00',
          endTime: '09:00',
          id: 27
        },
        {
          title: 'RCC INFORMANDO - SEGUNDA EDICION',
          description: '',
          announcers: 'Periodista Pocho Meza y Lic. Rodolfo Pastor Caceres',
          startTime: '09:00',
          endTime: '12:00',
          id: 28
        },
        {
          title: 'JARANA CRIOLLA',
          description: '',
          announcers: 'Lic. Mario Levano',
          startTime: '12:00',
          endTime: '13:00',
          id: 29
        },
        {
          title: 'ENLACE REGIONAL SUR',
          description: '',
          announcers: 'Periodistas de la Red de Comunicación Regional',
          startTime: '13:00',
          endTime: '14:00',
          id: 30
        },
        {
          title: 'RCC INFORMANDO - TERCERA EDICION',
          description: '',
          announcers: 'Periodistas Javier Rugos y Rouse Choque',
          startTime: '14:00',
          endTime: '16:00',
          id: 31
        },
        {
          title: 'CONCERTANDO',
          description: '',
          announcers: 'Lic. Elmer Malaga',
          startTime: '16:00',
          endTime: '17:00',
          id: 32
        },
        {
          title: 'TARDES MUSICALES EN RCC',
          description: 'Programa musical',
          announcers: 'DJ Walter Junior.',
          startTime: '17:00',
          endTime: '18:00',
          id: 33
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '18:00',
          endTime: '20:00',
          id: 34
        },
        {
          title: 'LOS CLASICOS DE LA SALSA',
          description: 'Programa musical con la mejor Salsa Clasica con sus mejores exponentes y sus exitos en Estudio y en Concierto.',
          announcers: '',
          startTime: '20:00',
          endTime: '22:00',
          id: 35
        },
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras, Latinoamericana.',
          announcers: '',
          startTime: '22:00',
          endTime: '24:00',
          id: 36
        }
      ]
    },
    {
      dayName: 'jueves',
      programs: [
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuedo, Ranchera, Latinoamericana',
          announcers: '',
          startTime: '00:00',
          endTime: '04:00',
          id: 37
        },
        {
          title: 'DEL CAMPO A LA CIUDAD',
          description: 'Programa musical: Música Latinoamericana y Cumbias del Recuerdo.',
          announcers: 'Periodista Socrates Machaca',
          startTime: '04:00',
          endTime: '06:00',
          id: 38
        },
        {
          title: 'RCC INFORMANDO - PRIMERA EDICION',
          description: '',
          announcers: 'Abog. Carlos Ticona Oviedo y Lic. Rodolfo Pastor',
          startTime: '06:00',
          endTime: '08:30',
          id: 39
        },
        {
          title: 'INEI TACNA INFORMA',
          description: '',
          announcers: 'Representantes del INEI sede Tacna',
          startTime: '08:30',
          endTime: '09:00',
          id: 40
        },
        {
          title: 'INDECOPI A TU SERVICIO',
          description: '',
          announcers: 'Representantes del INDECOPI sede Tacna.',
          startTime: '09:00',
          endTime: '09:30',
          id: 41
        },
        {
          title: 'RCC INFORMANDO - SEGUNDA EDICION',
          description: '',
          announcers: 'Periodista Pocho Meza y Lic. Rodolfo Pastor Caceres',
          startTime: '09:30',
          endTime: '12:00',
          id: 42
        },
        {
          title: 'JARANA CRIOLLA',
          description: '',
          announcers: 'Lic. Mario Levano',
          startTime: '12:00',
          endTime: '13:00',
          id: 43
        },
        {
          title: 'ENLACE REGIONAL SUR',
          description: '',
          announcers: 'Periodistas de la Red de Comunicación Regional',
          startTime: '13:00',
          endTime: '14:00',
          id: 44
        },
        {
          title: 'RCC INFORMANDO - TERCERA EDICION',
          description: '',
          announcers: 'Periodistas Javier Rugos y Rouse Choque',
          startTime: '14:00',
          endTime: '16:00',
          id: 45
        },
        {
          title: 'CONCERTANDO',
          description: '',
          announcers: ' Lic. Elmer Malaga',
          startTime: '16:00',
          endTime: '17:00',
          id: 46
        },
        {
          title: 'TARDES MUSICALES EN RCC',
          description: 'Programa musical',
          announcers: 'DJ Walter Junior',
          startTime: '17:00',
          endTime: '18:00',
          id: 47
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '18:00',
          endTime: '20:00',
          id: 48
        },
        {
          title: 'LOS CLASICOS DE LA SALSA',
          description: 'Programa musical con la mejor Salsa Clasica con sus mejores exponentes y sus exitos en Estudio y en Concierto',
          announcers: '',
          startTime: '20:00',
          endTime: '22:00',
          id: 49
        },
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras, Latinoamericana.',
          announcers: '',
          startTime: '22:00',
          endTime: '24:00',
          id: 50
        }
      ]
    },
    {
      dayName: 'viernes',
      programs: [
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuedo, Ranchera, Latinoamericana',
          announcers: '',
          startTime: '00:00',
          endTime: '03:00',
          id: 51
        },
        {
          title: 'DEL CAMPO A LA CIUDAD',
          description: 'Programa musical: Música Latinoamericana y Cumbias del Recuerdo.',
          announcers: 'Periodista Socrates Machaca',
          startTime: '03:00',
          endTime: '05:00',
          id: 52
        },
        {
          title: 'CHICHO Y SUS AMIGOS',
          description: 'Programa estelar de análisis y opinión sobre los hechos mas resaltantes de la semana, bajo la conducción y estilo del Periodista Chicho Calizaya e invitados, amenizado con la mejor música seleccionada de RCC',
          announcers: '',
          startTime: '05:00',
          endTime: '10:00',
          id: 53
        },
        {
          title: 'RCC INFORMANDO - SEGUNDA EDICION',
          description: '',
          announcers: 'Periodista Pocho Meza y Lic. Rodolfo Pastor Caceres',
          startTime: '10:00',
          endTime: '12:00',
          id: 54
        },
        {
          title: 'JARANA CRIOLLA',
          description: '',
          announcers: 'Lic. Mario Levano',
          startTime: '12:00',
          endTime: '13:00',
          id: 55
        },
        {
          title: 'ENLACE REGIONAL SUR',
          description: '',
          announcers: 'Periodistas de la Red de Comunicación Regiona',
          startTime: '13:00',
          endTime: '14:00',
          id: 56
        },
        {
          title: 'RCC INFORMANDO - TERCERA EDICION',
          description: '',
          announcers: 'Periodistas Javier Rugos y Rouse Choque',
          startTime: '14:00',
          endTime: '16:00',
          id: 57
        },
        {
          title: 'CONCERTANDO',
          description: '',
          announcers: 'Lic. Elmer Malaga',
          startTime: '16:00',
          endTime: '17:00',
          id: 58
        },
        {
          title: 'TARDES MUSICALES EN RCC',
          description: 'Programa musical',
          announcers: 'DJ Walter Junior',
          startTime: '17:00',
          endTime: '18:00',
          id: 59
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '18:00',
          endTime: '20:00',
          id: 60
        },
        {
          title: 'LOS CLASICOS DE LA SALSA',
          description: 'Programa musical con la mejor Salsa Clasica con sus mejores exponentes y sus exitos en Estudio y en Concierto',
          announcers: '',
          startTime: '20:00',
          endTime: '22:00',
          id: 61
        },
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras, Latinoamericana.',
          announcers: '',
          startTime: '22:00',
          endTime: '24:00',
          id: 62
        }
      ]
    },
    {
      dayName: 'sábado',
      programs: [
        {
          title: 'POR LAS RUTAS DE LA MUSICA',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuedo, Ranchera, Latinoamericana',
          announcers: '',
          startTime: '00:00',
          endTime: '05:00',
          id: 63
        },
        {
          title: 'CHICHO Y SUS AMIGOS',
          description: 'Programa estelar de análisis y opinión sobre los hechos mas resaltantes de la semana, bajo la conducción y estilo del Periodista Chicho Calizaya e invitados, amenizado con la mejor música seleccionada de RCC',
          announcers: '',
          startTime: '05:00',
          endTime: '9:30',
          id: 64
        },
        {
          title: 'LOS FINES DE SEMANA EN RCC',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras',
          announcers: '',
          startTime: '09:30',
          endTime: '10:30',
          id: 65
        },
        {
          title: 'LA HORA DE REFLEXION',
          description: '',
          announcers: 'Profesor Luis Liendo',
          startTime: '10:30',
          endTime: '11:30',
          id: 66
        },
        {
          title: 'SUTEP INFORMA',
          description: '',
          announcers: 'Representantes del SUTEP sede Tacna',
          startTime: '11:30',
          endTime: '12:30',
          id: 67
        },
        {
          title: 'JARANA CRIOLLA',
          description: '',
          announcers: 'Lic. Mario Levano',
          startTime: '12:30',
          endTime: '13:00',
          id: 68
        },
        {
          title: 'LOS FINES DE SEMANA EN RCC',
          description: 'Programa musical: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras',
          announcers: '',
          startTime: '13:00',
          endTime: '14:00',
          id: 69
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '14:00',
          endTime: '18:00',
          id: 70
        },
        {
          title: 'LOS INOLVIDABLES DE LA MUSICA',
          description: 'Especiales con la mejor Música del Recuerdo en Español e Ingles de los 60\'s, 70\'s y 80\'s',
          announcers: '',
          startTime: '18:00',
          endTime: '20:00',
          id: 71
        },
        {
          title: 'EL GRAN FIESTON DE RCC',
          description: 'Programa con la mejor música bailable y seleccionada de ayer, hoy y siempre: Salsa Clásica, Cumbias del Recuerdo, Merengues, Rock Clásico en Español e Inglés y Pachangeros',
          announcers: '',
          startTime: '20:00',
          endTime: '24:00',
          id: 72
        }
      ]
    },
    {
      dayName: 'domingo',
      programs: [
        {
          title: 'EL GRAN FIESTON DE RCC',
          description: 'Programa con la mejor música bailable y seleccionada de ayer, hoy y siempre: Salsa Clásica, Cumbias del Recuerdo, Merengues, Rock Clásico en Español e Inglés y Pachanguero',
          announcers: '',
          startTime: '00:00',
          endTime: '05:00',
          id: 73
        },
        {
          title: 'CHICHO Y SUS AMIGOS',
          description: 'Programa estelar de análisis y opinión sobre los hechos mas resaltantes de la semana, bajo la conducción y estilo del Periodista Chicho Calizaya e invitados, amenizado con la mejor música seleccionada de RCC',
          announcers: '',
          startTime: '05:00',
          endTime: '10:00',
          id: 74
        },
        {
          title: 'LA HORA DE INTEGRAR',
          description: 'Magazine conduccido y producido por la MDCGAL',
          announcers: '',
          startTime: '10:00',
          endTime: '11:00',
          id: 75
        },
        {
          title: 'DOMINGOS ANTES DE LAS 12',
          description: 'Magazine informativo y musical',
          announcers: 'Abog. Carlos Ticona Oviedo',
          startTime: '11:00',
          endTime: '13:00',
          id: 76
        },
        {
          title: 'LOS CLASICOS DE LA SALSA',
          description: 'La mejor Salsa Clásica con sus mejores exponentes y sus éxitos en estudio y en Concierto',
          announcers: '',
          startTime: '13:00',
          endTime: '14:00',
          id: 77
        },
        {
          title: 'LA HORA ESTELAR DE CAMILACA Y SUS INVITADOS',
          description: 'Programa musical ',
          announcers: 'Jesus Paucar Moreano e invitados',
          startTime: '14:00',
          endTime: '18:00',
          id: 78
        },
        {
          title: 'DOMINGOS FAMILIARES EN RCC',
          description: 'Programa con la mejor música seleccionada de RCC: Música del Recuerdo, Boleros, Valses, Pasillos, Salsa Clásica, Cumbia del Recuerdo, Rancheras, Latinoamericana',
          announcers: '',
          startTime: '18:00',
          endTime: '24:00',
          id: 79
        }
      ]
    }
  ]
}

const mutations = {
  [types.SELECT_DAY] (state, dayName) {
    state.selectedDay = dayName
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/programs/index.js